import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-process',
  templateUrl: './application-process.component.html',
  styleUrls: ['./application-process.component.scss']
})
export class ApplicationProcessComponent implements OnInit {
  admissionRequirements: any = [
    {
      heading: 'Admission Requirements',
      items: [
        'Completed PAI University application and application fee payment $100.',
        'Copy of government issued photo ID.',
        'Current resume or CV.',
        'Any non-English documentation must have a certified English translation.',
        'Transcripts not in English are evaluated by an appropriate third party and translated into English at the expense of the student.'
      ]
    },
    {
      heading: 'Undergraduate Admission',
      items: [
        'Copy of high school diploma or its equivalent.',
        'Copy of high school transcripts.',
        'Current photo identification; ID or passport.'
      ]
    },
    {
      heading: 'Graduate Admission',
      items: [
        '2 Letters of recommendation from faculty or employer.',
        'Updated resume/CV.',
        'Copy of each diploma: bachelor’s degree and high school diploma.',
        'Original transcript of last received degree.',
        'Current photo identification – ID or passport.'
      ]
    },
    {
      heading: 'Doctorate Admission',
      items: [
        'Letter of intent for admission to the doctoral program.',
        'A work statement letter (Minimum of 3 years of experience).',
        '3 Letters of recommendation from faculty, colleagues, or employers.',
        'Updated resume/CV.',
        'Copy of each diploma: master’s degree, bachelor’s degree and high school diploma.',
          'Original transcript of last received degree.' ,
          'Current photo identification – ID or passport.'
      ]
    }
  ];


  constructor() { }

  ngOnInit(): void {
  }

}
